import { useEffect } from "react";

// Posts the rendered content height to the parent window so the host page can
// auto-fit the iframe (grow AND shrink). The embed snippet listens for these.
export function useEmbedAutoResize(deps = []) {
  useEffect(() => {
    if (window.parent === window) return; // opened directly, not embedded
    const fid = new URLSearchParams(window.location.search).get("fid");
    const measure = () => {
      // Measure the rendered content element, NOT documentElement/body
      // scrollHeight — those are clamped up to the iframe viewport and can
      // never shrink below the current frame height.
      const root = document.querySelector("[data-embed-root]");
      const h = root ? root.getBoundingClientRect().height : document.body.getBoundingClientRect().height;
      return Math.ceil(h);
    };
    const post = () => {
      window.parent.postMessage({ type: "hirescope-embed-height", id: fid, height: measure() }, "*");
    };
    post();
    const raf = requestAnimationFrame(post);
    const t = setTimeout(post, 300);
    let ro;
    const root = document.querySelector("[data-embed-root]");
    if (window.ResizeObserver && root) {
      ro = new ResizeObserver(post);
      ro.observe(root);
    }
    window.addEventListener("load", post);
    window.addEventListener("resize", post);
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(t);
      if (ro) ro.disconnect();
      window.removeEventListener("load", post);
      window.removeEventListener("resize", post);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
